export default __webpack_public_path__ + "static/media/i_bus-tro_yl.b4c55b30.svg";